<template>


  
  <QueueDefaultWidget
    v-if="template === 'boxes'"
    :queueData="queueData"
    :queueConfig="queueConfig"
    :border-radius="borderRadius"
    :numberTxt="numberTxt"
    :counterTxt="counterTxt"
    :config="config"
  />
  <QueueLeafWidget
    v-if="template === 'leaf'"
    :queueData="queueData"
    :queueConfig="queueConfig"
    :border-radius="borderRadius"
    :numberTxt="numberTxt"
    :counterTxt="counterTxt"
    :config="config"
  />
</template>

<script lang="ts">
export default {
  name: "QueueDefaultWidget",
};
</script>

<script setup lang="ts">
import QueueDefaultWidget from "@/components/dynamic/QueueDefaultWidget.vue";
import QueueLeafWidget from "@/components/dynamic/QueueLeafWidget.vue";
import { ref, defineProps, computed, onMounted, nextTick } from "vue";
const props = defineProps<{
  queueData: Array<any>;
  queueConfig: any;
  borderRadius: number;
  config: any;
}>();

const template = computed(() => {
  if (!props.config.queueConfig.template) {
    return "boxes";
  }
  return props.config.queueConfig.template;
});

//set counter and number text
const numberTxt = ref("");
const counterTxt = ref("");
const setHeaderText = () => {
  const displayData = JSON.parse(localStorage.getItem("display") || "{}");
  const config = JSON.parse(displayData.config);
  const voiceCall = config.voice_call;
  if (voiceCall == 1) {
    counterTxt.value = config.textCounter;
    numberTxt.value = config.textNumber;
  }else{
    const lang = localStorage.getItem("Language");
    if (lang == "fr") {
      counterTxt.value = "Guichet";
      numberTxt.value = "Numéro";
    }else if (lang == "en") {
      counterTxt.value = "Counter";
      numberTxt.value = "Number";
    }else{
      counterTxt.value = "شباك";
      numberTxt.value = "رقم";
    }
  }
}

onMounted(() => {
  setHeaderText();
})


</script>

<style scoped>

</style>